export default __webpack_public_path__ + "static/media/marketin_ eclini.deec0e0a.svg";